import { getFormValues } from 'redux-form';
import apiRequest from '@libs/apiRequest';
import { FORM_NAME } from 'employee/ManageEmployee/common';
import { call, put, select } from 'redux-saga/effects';
import { setLoading, setSnack } from 'utilities/redux.actions';

function getCalenderId(calenders, name) {
    return calenders.filter((item) => item.name === name)[0]?.id || name;
}

function FormData_append_object(fd, obj, key) {
    var i, k;
    for (i in obj) {
        k = key ? key + '[' + i + ']' : i;
        if (obj[i] === undefined || obj[i] === null) continue;
        if (typeof obj[i] == 'object') {
            FormData_append_object(fd, obj[i], k);
        } else fd.append(k, obj[i]);
    }
}

const makeEmployeeInfoPayload = ({
    employeeEmail,
    employeeId,
    reportingManager,
    joiningDate,
    department,
    officeBranch,
    designation,
    employeeCategory,
    calenderId
}) => {
    const payload = {};

    if (employeeId) payload.employeeId = employeeId;
    if (reportingManager) payload.reportingManager = reportingManager;
    if (joiningDate) payload.joiningDate = joiningDate;
    if (department) payload.department = { name: department };
    if (officeBranch) payload.branch = { name: officeBranch };
    if (designation) payload.designation = { name: designation };
    if (employeeCategory) payload.employeeCategory = { name: employeeCategory };
    if (calenderId) payload.calenderId = calenderId;

    return payload;
};

export default function* (action) {
    const {
        meta: { handleSubmit = () => {} }
    } = action;

    yield put(setLoading(true));

    const formValues = yield select(getFormValues(FORM_NAME));
    const { employeeEmail } = formValues;

    // Get calendar ID from name
    const {
        data: { data: calenders }
    } = yield call(apiRequest, {
        url: `calender/get/all`,
        method: 'get'
    });
    const calendarId = getCalenderId(calenders, formValues.calenderId);
    formValues.calenderId = calendarId;

    const employeeInfoPayload = makeEmployeeInfoPayload(formValues);

    // Convert to FormData (same as employeePublishWorker)
    let formData = new FormData();
    FormData_append_object(formData, employeeInfoPayload);

    console.log('Form values:', formValues);
    console.log('Sending employee info payload:', employeeInfoPayload);

    try {
        const { data } = yield call(apiRequest, {
            url: `employee/update?email=${employeeEmail}`,
            method: 'put',
            data: formData
        });

        yield put(
            setSnack({
                message: 'Employee Information Updated Successfully',
                type: 'success'
            })
        );

        yield put(setLoading(false));
        handleSubmit(data);
    } catch (error) {
        yield put(setLoading(false));
        yield put(
            setSnack({
                message: error?.response?.data?.message || error?.message,
                type: 'error'
            })
        );
    }
}
